export default {
    "card": [
        {
            "groupName": "header",
            "items": [
                {
                    name: ".bolt-card-with-header",
                    description: "Apply this class name to a CustomCard which contains a CardHeader. The CardHeader will have the appropriate vertical spacing, so this className will remove the card's default padding-top."
                },
            ]
        },
        {
            "groupName": "table",
            "items": [
                {
                    name: ".bolt-table-card",
                    description: "Apply this class name to a card where the only content is a table. The card can still have a Header / Footer, but this class will get the card's padding correct."
                },
            ]
        },
    ],
    "colors": [
        {
            "groupName": "communication",
            "items": [
                {
                    name: "$communication-shade-30",
                    description: "Communication shaded-30 (darkened)",
                    value: "rgbcolor(var(--palette-primary-shade-30))"
                },
                {
                    name: "$communication-shade-20",
                    description: "Communication shaded-20 (darkened)",
                    value: "rgbcolor(var(--palette-primary-shade-20))"
                },
                {
                    name: "$communication-shade-10",
                    description: "Communication shaded-10 (darkened)",
                    value: "rgbcolor(var(--palette-primary-shade-10))"
                },
                {
                    name: "$communication-foreground",
                    description: "Primary communication for foreground (text)",
                    value: "var(--communication-foreground)"
                },
                {
                    name: "$communication-background",
                    description: "Primary communication for background",
                    value: "var(--communication-background)"
                },
                {
                    name: "$communication-tint-10",
                    description: "Communication tinted-10 (lightened)",
                    value: "rgbcolor(var(--palette-primary-tint-10))"
                },
                {
                    name: "$communication-tint-20",
                    description: "Communication tinted-20 (lightened)",
                    value: "rgbcolor(var(--palette-primary-tint-20))"
                },
                {
                    name: "$communication-tint-30",
                    description: "Communication tinted-30 (lightened)",
                    value: "rgbcolor(var(--palette-primary-tint-30))"
                },
                {
                    name: "$communication-tint-40",
                    description: "Communication tinted-40 (lightened)",
                    value: "rgbcolor(var(--palette-primary-tint-40))"
                },
                {
                    name: "$communication-background-active",
                    description: "Communication background active color",
                    value: "rgbcolor(var(--palette-primary-darkened-10))"
                },
                {
                    name: "$communication-background-hover",
                    description: "Communication background hover color",
                    value: "rgbcolor(var(--palette-primary-darkened-6))"
                },
            ]
        },
        {
            "groupName": "miscellaneous",
            "items": [
                {
                    name: "$favorite-icon-color",
                    description: "Favorite star icon color",
                    value: "rgbcolor(var(--palette-accent3-dark))"
                },
            ]
        },
        {
            "groupName": "neutral-alphas",
            "items": [
                {
                    name: "$neutral-alpha-80",
                    description: "80% black",
                    value: "var(--palette-black-alpha-80)"
                },
                {
                    name: "$neutral-alpha-70",
                    description: "70% black",
                    value: "var(--palette-black-alpha-70)"
                },
                {
                    name: "$neutral-alpha-60",
                    description: "60% black",
                    value: "var(--palette-black-alpha-60)"
                },
                {
                    name: "$neutral-alpha-30",
                    description: "30% black",
                    value: "var(--palette-black-alpha-30)"
                },
                {
                    name: "$neutral-alpha-20",
                    description: "20% black",
                    value: "var(--palette-black-alpha-20)"
                },
                {
                    name: "$neutral-alpha-10",
                    description: "10% black",
                    value: "var(--palette-black-alpha-10)"
                },
                {
                    name: "$neutral-alpha-8",
                    description: "8% black",
                    value: "var(--palette-black-alpha-8)"
                },
                {
                    name: "$neutral-alpha-6",
                    description: "6% black",
                    value: "var(--palette-black-alpha-6)"
                },
                {
                    name: "$neutral-alpha-4",
                    description: "4% black",
                    value: "var(--palette-black-alpha-4)"
                },
                {
                    name: "$neutral-alpha-2",
                    description: "2% black",
                    value: "var(--palette-black-alpha-2)"
                },
            ]
        },
        {
            "groupName": "neutrals",
            "items": [
                {
                    name: "$black",
                    description: "Neutral-100 (black)",
                    value: "rgbcolor(var(--palette-neutral-100))"
                },
                {
                    name: "$neutral-80",
                    description: "Neutral-80",
                    value: "rgbcolor(var(--palette-neutral-80))"
                },
                {
                    name: "$neutral-70",
                    description: "Neutral-70",
                    value: "rgbcolor(var(--palette-neutral-70))"
                },
                {
                    name: "$neutral-60",
                    description: "Neutral-60",
                    value: "rgbcolor(var(--palette-neutral-60))"
                },
                {
                    name: "$neutral-30",
                    description: "Neutral-30",
                    value: "rgbcolor(var(--palette-neutral-30))"
                },
                {
                    name: "$neutral-20",
                    description: "Neutral-20",
                    value: "rgbcolor(var(--palette-neutral-20))"
                },
                {
                    name: "$neutral-10",
                    description: "Neutral-10",
                    value: "rgbcolor(var(--palette-neutral-10))"
                },
                {
                    name: "$neutral-8",
                    description: "Neutral-8",
                    value: "rgbcolor(var(--palette-neutral-8))"
                },
                {
                    name: "$neutral-6",
                    description: "Neutral-6",
                    value: "rgbcolor(var(--palette-neutral-6))"
                },
                {
                    name: "$neutral-4",
                    description: "Neutral-4",
                    value: "rgbcolor(var(--palette-neutral-4))"
                },
                {
                    name: "$neutral-2",
                    description: "Neutral-2",
                    value: "rgbcolor(var(--palette-neutral-2))"
                },
                {
                    name: "$neutral-0",
                    description: "Neutral-0 (white)",
                    value: "rgbcolor(var(--palette-neutral-0))"
                },
            ]
        },
        {
            "groupName": "status",
            "items": [
                {
                    name: "$status-info-foreground",
                    description: "Info foreground color",
                    value: "var(--status-info-foreground)"
                },
                {
                    name: "$status-info-background",
                    description: "Info background color",
                    value: "var(--status-info-background)"
                },
                {
                    name: "$status-error-foreground",
                    description: "Error foreground color",
                    value: "var(--status-error-foreground)"
                },
                {
                    name: "$status-error-background",
                    description: "Error background color",
                    value: "var(--status-error-background)"
                },
                {
                    name: "$status-error-text",
                    description: "Error text color",
                    value: "var(--status-error-text)"
                },
                {
                    name: "$status-success-foreground",
                    description: "Success foreground color",
                    value: "var(--status-success-foreground)"
                },
                {
                    name: "$status-success-background",
                    description: "Success background color",
                    value: "var(--status-success-background)"
                },
                {
                    name: "$status-success-text",
                    description: "Success text color",
                    value: "var(--status-success-text)"
                },
                {
                    name: "$status-warning-icon-foreground",
                    description: "Warning foreground icon color",
                    value: "var(--status-warning-icon-foreground)"
                },
                {
                    name: "$status-warning-foreground",
                    description: "Warning foreground color",
                    value: "var(--status-warning-foreground)"
                },
                {
                    name: "$status-warning-background",
                    description: "Warning background color",
                    value: "var(--status-warning-background)"
                },
                {
                    name: "$status-warning-text",
                    description: "Warning text color",
                    value: "var(--status-warning-text)"
                },
            ]
        },
        {
            "groupName": "text-color",
            "items": [
                {
                    name: "$backgroundColor",
                    description: "Main background color",
                    value: "var(--background-color)"
                },
                {
                    name: "$primary-text",
                    description: "Main text (foreground) color",
                    value: "var(--text-primary-color)"
                },
                {
                    name: "$secondary-text",
                    description: "Secondary text color",
                    value: "var(--text-secondary-color)"
                },
                {
                    name: "$disabled-text",
                    description: "Disabled text color",
                    value: "var(--text-disabled-color)"
                },
                {
                    name: "$disabled-text-invert",
                    description: "Disabled text color inverse",
                    value: "rgbcolor(var(--palette-neutral-0), 0.38)"
                },
                {
                    name: "$text-on-communication-background",
                    description: "Text color to use on communication (colored) backgrounds. This is always a light color independent of light/dark theme.",
                    value: "var(--text-on-communication-background)"
                },
            ]
        },
    ],
    "core": [
        {
            "groupName": "alignment",
            "items": [
                {
                    name: ".v-align-middle",
                    description: "vertical-align: middle"
                },
            ]
        },
        {
            "groupName": "border",
            "items": [
                {
                    name: ".separator-line-top",
                    description: "separator line above the element"
                },
                {
                    name: ".separator-line-bottom",
                    description: "separator line below the element"
                },
                {
                    name: ".subtle-border",
                    description: "subtle border around the element"
                },
            ]
        },
        {
            "groupName": "cursor",
            "items": [
                {
                    name: ".cursor-default",
                    description: "cursor: default"
                },
                {
                    name: ".cursor-pointer",
                    description: "cursor: pointer"
                },
            ]
        },
        {
            "groupName": "depth",
            "items": [
                {
                    name: ".depth-0",
                    description: "No box-shadow"
                },
                {
                    name: ".depth-4",
                    description: "4px box-shadow"
                },
                {
                    name: ".depth-8",
                    description: "8px box-shadow"
                },
                {
                    name: ".depth-16",
                    description: "16px box-shadow"
                },
                {
                    name: ".depth-64",
                    description: "64px box-shadow"
                },
            ]
        },
        {
            "groupName": "flex-box",
            "items": [
                {
                    name: ".flex-column",
                    description: "display: flex and flex-direction: column"
                },
                {
                    name: ".flex-row",
                    description: "display: flex and flex-direction: row"
                },
                {
                    name: ".inline-flex-column",
                    description: "display: inline-flex and flex-direction: column"
                },
                {
                    name: ".inline-flex-row",
                    description: "display: inline-flex and flex-direction: row"
                },
                {
                    name: ".flex-center",
                    description: "align-items: center"
                },
                {
                    name: ".flex-end",
                    description: "align-items: flex-end"
                },
                {
                    name: ".flex-start",
                    description: "align-items: flex-start"
                },
                {
                    name: ".flex-stretch",
                    description: "align-items: stretch"
                },
                {
                    name: ".flex-baseline",
                    description: "align-items: baseline"
                },
                {
                    name: ".justify-start",
                    description: "justify-content: flex-start"
                },
                {
                    name: ".justify-center",
                    description: "justify-content: center"
                },
                {
                    name: ".justify-end",
                    description: "justify-content: flex-end"
                },
                {
                    name: ".justify-space-between",
                    description: "justify-content: space-between"
                },
                {
                    name: ".flex-wrap",
                    description: "flex-wrap: wrap"
                },
                {
                    name: ".flex-cell",
                    description: "Makes an element a row-based flex box, with items aligned center and no margin/padding."
                },
            ]
        },
        {
            "groupName": "flex-item",
            "items": [
                {
                    name: ".flex-grow",
                    description: "flex-grow: 1"
                },
                {
                    name: ".flex-noshrink",
                    description: "flex-shrink: 0"
                },
                {
                    name: ".flex-self-center",
                    description: "align-self: center"
                },
                {
                    name: ".flex-self-end",
                    description: "align-self: flex-end"
                },
                {
                    name: ".flex-self-start",
                    description: "align-self: flex-start"
                },
                {
                    name: ".flex-self-stretch",
                    description: "align-self: stretch"
                },
            ]
        },
        {
            "groupName": "font-size",
            "items": [
                {
                    name: ".font-size-xxs",
                    description: "font-size: 9px"
                },
                {
                    name: ".font-size-xs",
                    description: "font-size: 10px"
                },
                {
                    name: ".font-size-s",
                    description: "font-size: 11px"
                },
                {
                    name: ".font-size",
                    description: "font-size: 12px"
                },
                {
                    name: ".font-size-ms",
                    description: "font-size: 13px"
                },
                {
                    name: ".font-size-m",
                    description: "font-size: 14px"
                },
                {
                    name: ".font-size-mm",
                    description: "font-size: 15px"
                },
                {
                    name: ".font-size-ml",
                    description: "font-size: 16px"
                },
                {
                    name: ".font-size-l",
                    description: "font-size: 18px"
                },
                {
                    name: ".font-size-ll",
                    description: "font-size: 24px"
                },
                {
                    name: ".font-size-lll",
                    description: "font-size: 28px"
                },
                {
                    name: ".font-size-xl",
                    description: "font-size: 36px"
                },
                {
                    name: ".font-size-xxl",
                    description: "font-size: 40px"
                },
                {
                    name: ".font-size-xxxl",
                    description: "font-size: 56px"
                },
                {
                    name: ".font-size-xxxxl",
                    description: "font-size: 72px"
                },
            ]
        },
        {
            "groupName": "font-weight",
            "items": [
                {
                    name: ".font-weight-light",
                    description: "font-weight: 200"
                },
                {
                    name: ".font-weight-normal",
                    description: "font-weight: normal"
                },
                {
                    name: ".font-weight-semibold",
                    description: "font-weight: 600"
                },
                {
                    name: ".font-weight-heavy",
                    description: "font-weight: bold"
                },
            ]
        },
        {
            "groupName": "icon",
            "items": [
                {
                    name: ".icon-margin",
                    description: "6px margin-right, separates icon and text"
                },
                {
                    name: ".icon-large-margin",
                    description: "12px margin-right, separates icon and text"
                },
            ]
        },
        {
            "groupName": "layer",
            "items": [
                {
                    name: ".sub-layer",
                    description: "Indicates another layer should be used (z-index: 10)"
                },
            ]
        },
        {
            "groupName": "layout",
            "items": [
                {
                    name: ".absolute-fill",
                    description: "Makes an element absolutely positioned and fill the entire space."
                },
                {
                    name: ".absolute",
                    description: "position: absolute"
                },
                {
                    name: ".relative",
                    description: "position: relative"
                },
                {
                    name: ".no-events",
                    description: "pointer-events: none"
                },
            ]
        },
        {
            "groupName": "link",
            "items": [
                {
                    name: ".link-icon",
                    description: "2px padding used for icons within a link."
                },
                {
                    name: ".link-text",
                    description: "2px vertical padding used for text within a link."
                },
            ]
        },
        {
            "groupName": "margin",
            "items": [
                {
                    name: ".margin-0, .no-margin",
                    description: "Removes all margin from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".margin-4",
                    description: "Adds 4px of margin to all sides of the element"
                },
                {
                    name: ".margin-8",
                    description: "Adds 8px of margin to all sides of the element"
                },
                {
                    name: ".margin-16",
                    description: "Adds 16px of margin to all sides of the element"
                },
                {
                    name: ".margin-bottom-4",
                    description: "Adds 4px of margin to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-bottom-8",
                    description: "Adds 8px of margin to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-bottom-16",
                    description: "Adds 16px of margin to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-horizontal-0, .no-h-margin",
                    description: "Removes all horizontal margin from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".margin-horizontal-4",
                    description: "Adds 4px of margin to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".margin-horizontal-8",
                    description: "Adds 8px of margin to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".margin-horizontal-16",
                    description: "Adds 16px of margin to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".margin-horizontal-20",
                    description: "Adds 20px of margin to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".margin-left-4",
                    description: "Adds 4px of margin to the left leaving the other sides unaffected"
                },
                {
                    name: ".margin-left-8",
                    description: "Adds 8px of margin to the left leaving the other sides unaffected"
                },
                {
                    name: ".margin-left-16",
                    description: "Adds 16px of margin to the left leaving the other sides unaffected"
                },
                {
                    name: ".margin-right-4",
                    description: "Adds 4px of margin to the right leaving the other sides unaffected"
                },
                {
                    name: ".margin-right-8",
                    description: "Adds 8px of margin to the right leaving the other sides unaffected"
                },
                {
                    name: ".margin-right-16",
                    description: "Adds 16px of margin to the right leaving the other sides unaffected"
                },
                {
                    name: ".margin-top-4",
                    description: "Adds 4px of margin to the top leaving the other sides unaffected"
                },
                {
                    name: ".margin-top-8",
                    description: "Adds 8px of margin to the top leaving the other sides unaffected"
                },
                {
                    name: ".margin-top-16",
                    description: "Adds 16px of margin to the top leaving the other sides unaffected"
                },
                {
                    name: ".margin-vertical-0, .no-v-margin",
                    description: "Removes all vertical margin from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".margin-vertical-4",
                    description: "Adds 4px of margin to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-vertical-8",
                    description: "Adds 8px of margin to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-vertical-16",
                    description: "Adds 16px of margin to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".margin-vertical-20",
                    description: "Adds 20px of margin to the top and bottom leaving the other sides unaffected"
                },
            ]
        },
        {
            "groupName": "overflow",
            "items": [
                {
                    name: ".scroll-hidden",
                    description: "overflow: hidden"
                },
                {
                    name: ".v-scroll-hidden",
                    description: "overflow-y: hidden"
                },
                {
                    name: ".h-scroll-hidden",
                    description: "overflow-x: hidden"
                },
                {
                    name: ".scroll-auto",
                    description: "overflow: auto"
                },
                {
                    name: ".v-scroll-auto",
                    description: "overflow-y: auto"
                },
                {
                    name: ".h-scroll-auto",
                    description: "overflow-x: auto"
                },
                {
                    name: ".full-height",
                    description: "height: 100%"
                },
                {
                    name: ".full-size",
                    description: "Makes an element a row-based flex-box, flex-grow: 1, and overflow: hidden."
                },
                {
                    name: ".full-width",
                    description: "width: 100%"
                },
            ]
        },
        {
            "groupName": "padding",
            "items": [
                {
                    name: ".shadow-padding",
                    description: "Adds 4px of negative margin and 4 px of (positive) padding to offset it. This results in no visual padding, but allows shadows (e.g. from focus rects, Cards) to display outside of their boundary."
                },
                {
                    name: ".padding-0, .no-padding",
                    description: "Removes all padding from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".padding-4",
                    description: "Adds 4px of padding to all sides of the element"
                },
                {
                    name: ".padding-8",
                    description: "Adds 8px of padding to all sides of the element"
                },
                {
                    name: ".padding-16",
                    description: "Adds 16px of padding to all sides of the element"
                },
                {
                    name: ".padding-bottom-0, .no-bottom-padding",
                    description: "Removes bottom padding from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".padding-bottom-4",
                    description: "Adds 4px of padding to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-bottom-8",
                    description: "Adds 8px of padding to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-bottom-16",
                    description: "Adds 16px of padding to the bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-horizontal-0, .no-h-padding",
                    description: "Removes all horizontal padding from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".padding-horizontal-4",
                    description: "Adds 4px of padding to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".padding-horizontal-8",
                    description: "Adds 8px of padding to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".padding-horizontal-16",
                    description: "Adds 16px of padding to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".padding-horizontal-20",
                    description: "Adds 20px of padding to the left and right leaving the other sides unaffected"
                },
                {
                    name: ".padding-left-4",
                    description: "Adds 4px of padding to the left leaving the other sides unaffected"
                },
                {
                    name: ".padding-left-8",
                    description: "Adds 8px of padding to the left leaving the other sides unaffected"
                },
                {
                    name: ".padding-left-16",
                    description: "Adds 16px of padding to the left leaving the other sides unaffected"
                },
                {
                    name: ".padding-right-4",
                    description: "Adds 4px of padding to the right leaving the other sides unaffected"
                },
                {
                    name: ".padding-right-8",
                    description: "Adds 8px of padding to the right leaving the other sides unaffected"
                },
                {
                    name: ".padding-right-16",
                    description: "Adds 16px of padding to the right leaving the other sides unaffected"
                },
                {
                    name: ".padding-top-0, .no-top-padding",
                    description: "Removes top padding from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".padding-top-4",
                    description: "Adds 4px of padding to the top leaving the other sides unaffected"
                },
                {
                    name: ".padding-top-8",
                    description: "Adds 8px of padding to the top leaving the other sides unaffected"
                },
                {
                    name: ".padding-top-16",
                    description: "Adds 16px of padding to the top leaving the other sides unaffected"
                },
                {
                    name: ".padding-vertical-0, .no-v-padding",
                    description: "Removes all vertical padding from an element. Not intended to be used as the default, only to override defaults"
                },
                {
                    name: ".padding-vertical-4",
                    description: "Adds 4px of padding to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-vertical-8",
                    description: "Adds 8px of padding to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-vertical-16",
                    description: "Adds 16px of padding to the top and bottom leaving the other sides unaffected"
                },
                {
                    name: ".padding-vertical-20",
                    description: "Adds 20px of padding to the top and bottom leaving the other sides unaffected"
                },
            ]
        },
        {
            "groupName": "rhythm",
            "items": [
                {
                    name: ".rhythm-horizontal-4",
                    description: "Spaces children by 4px using left-margin"
                },
                {
                    name: ".rhythm-horizontal-8",
                    description: "Spaces children by 8px using left-margin"
                },
                {
                    name: ".rhythm-horizontal-16",
                    description: "Spaces children by 16px using left-margin"
                },
                {
                    name: ".rhythm-vertical-4",
                    description: "Spaces children by 4px using top-margin"
                },
                {
                    name: ".rhythm-vertical-8",
                    description: "Spaces children by 8px using top-margin"
                },
                {
                    name: ".rhythm-vertical-16",
                    description: "Spaces children by 16px using top-margin"
                },
                {
                    name: ".rhythm-vertical-20",
                    description: "Spaces children by 20px using top-margin"
                },
                {
                    name: ".rhythm-vertical-24",
                    description: "Spaces children by 24px using top-margin"
                },
                {
                    name: ".rhythm-vertical-32",
                    description: "Spaces children by 32px using top-margin"
                },
            ]
        },
        {
            "groupName": "scrollbar",
            "items": [
                {
                    name: ".custom-scrollbar",
                    description: "Overrides the default scrollbar with a custom one. Only works in browsers supporting webkit-scrollbar or scrollbar-color/width."
                },
            ]
        },
        {
            "groupName": "shimmer",
            "items": [
                {
                    name: ".shimmer",
                    description: "Sets up a basic animation intended to mock the data shape being loaded with a small shimmer effect."
                },
                {
                    name: ".shimmer-line",
                    description: "This shimmer-line style will use a wide animation and provide proportional corners to look like a line."
                },
                {
                    name: ".shimmer-circle-small",
                    description: "This shimmer-circle-small style will use a circular element with a thin animation, this is used for small prefixes."
                },
                {
                    name: ".shimmer-circle-large",
                    description: "This shimmer-circle-large style will use a circular element with a thin animation, this is used for large prefixes."
                },
            ]
        },
        {
            "groupName": "spacing",
            "items": [
                {
                    name: "$spacingBorder",
                    description: "1px",
                    value: "1px"
                },
                {
                    name: "$spacingFocusRect",
                    description: "3px",
                    value: "3px"
                },
                {
                    name: "$spacing-4",
                    description: "spacing-XXS",
                    value: "4px"
                },
                {
                    name: "$spacing-8",
                    description: "spacing-XS",
                    value: "8px"
                },
                {
                    name: "$spacing-12",
                    description: "spacing-S",
                    value: "12px"
                },
                {
                    name: "$spacing-16",
                    description: "spacing-M",
                    value: "16px"
                },
                {
                    name: "$spacing-20",
                    description: "spacing-L",
                    value: "20px"
                },
                {
                    name: "$spacing-24",
                    description: "",
                    value: "24px"
                },
                {
                    name: "$spacing-32",
                    description: "spacing-XL",
                    value: "32px"
                },
                {
                    name: "$spacing-40",
                    description: "spacing-XXL",
                    value: "40px"
                },
            ]
        },
        {
            "groupName": "text",
            "items": [
                {
                    name: ".text-ellipsis",
                    description: "Apply to an element to make its text ellipsis (a parent must have overflow hidden)"
                },
                {
                    name: ".text-left",
                    description: "text-align: left"
                },
                {
                    name: ".text-center",
                    description: "text-align: center"
                },
                {
                    name: ".text-right",
                    description: "text-align: right"
                },
                {
                    name: ".white-space-nowrap",
                    description: "white-space: nowrap;"
                },
                {
                    name: ".word-break",
                    description: "Ensure text wraps even when there are no appropriate break characters."
                },
                {
                    name: ".selectable-text",
                    description: "Apply to an element t make the text within it selectable."
                },
            ]
        },
        {
            "groupName": "typography",
            "items": [
                {
                    name: "$fontFamily",
                    description: "Default (Segoe UI) font family",
                    value: "\"Segoe UI\", \"-apple-system\", BlinkMacSystemFont, Roboto, \"Helvetica Neue\", Helvetica, Ubuntu, Arial, sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\""
                },
                {
                    name: "$fontFamilyMonospace",
                    description: "Fixed-width (code) font family",
                    value: "\"Cascadia Mono\", Menlo, Consolas, Courier New, monospace"
                },
                {
                    name: "$fontWeightHeavy",
                    description: "Heavy (bold) font weight",
                    value: "bold"
                },
                {
                    name: "$fontWeightNormal",
                    description: "Normal font weight",
                    value: "normal"
                },
                {
                    name: "$fontWeightLighter",
                    description: "Light (200) font weight",
                    value: "200"
                },
                {
                    name: "$fontWeightSemiBold",
                    description: "Semi-bold (600) font weight",
                    value: "600"
                },
                {
                    name: ".title-l",
                    description: "Bold, 28px"
                },
                {
                    name: ".title-m",
                    description: "Semibold, 21px"
                },
                {
                    name: ".title-s",
                    description: "Semibold, 17px"
                },
                {
                    name: ".title-xs",
                    description: "Semibold, 15px"
                },
                {
                    name: ".body-xl",
                    description: "17px font, with 24px line height"
                },
                {
                    name: ".body-l",
                    description: "15px font, with 20x line height"
                },
                {
                    name: ".body-m",
                    description: "14px font, with 20px line height"
                },
                {
                    name: ".body-s",
                    description: "12px font, with 16px line height"
                },
                {
                    name: ".body-xs",
                    description: "10px font, with 16px line height"
                },
                {
                    name: ".monospaced-m",
                    description: "13px monospaced font with 20px line height"
                },
                {
                    name: ".monospaced-s",
                    description: "12px monospaced font with 20px line height"
                },
                {
                    name: ".monospaced-xs",
                    description: "12px monospaced font with 16px line height"
                },
                {
                    name: ".secondary-text",
                    description: "Uses the secondary text color (theme-dependent)"
                },
                {
                    name: ".monospaced-text",
                    description: "Uses a monospaced font family (Menlo, Consolas, Courier New, monospace)"
                },
                {
                    name: ".error-text",
                    description: "Uses the error text color"
                },
            ]
        },
        {
            "groupName": "visibility",
            "items": [
                {
                    name: ".hidden",
                    description: "display: none"
                },
                {
                    name: ".invisible",
                    description: "visibility: hidden"
                },
                {
                    name: ".rotate-180",
                    description: "rotate 180 degrees"
                },
            ]
        },
    ],
    "dropdown": [
        {
            "groupName": "actions",
            "items": [
                {
                    name: ".bolt-dropdown-action-right-button",
                    description: "Apply to actions that should appear right aligned."
                },
            ]
        },
    ],
    "table": [
        {
            "groupName": "link",
            "items": [
                {
                    name: ".bolt-table-cell-content-with-link",
                    description: "Apply to a cell's content if the cell contains only a link."
                },
                {
                    name: ".bolt-table-cell-content-with-inline-link",
                    description: "Apply to a cell's content if the cell contains an inline link, along with other content."
                },
                {
                    name: ".bolt-table-cell-content-with-button",
                    description: "Apply to a cell's content if the cell contains a button."
                },
                {
                    name: ".bolt-table-link.bolt-link",
                    description: "Apply bolt-table-link to a link in a table."
                },
                {
                    name: ".bolt-table-inline-link.bolt-table-link",
                    description: "Apply to a link in a table that is inline - meaning there are multiple links or other non-link content in the cell."
                },
            ]
        },
        {
            "groupName": "visibility",
            "items": [
                {
                    name: ".bolt-table-cell-content-reveal",
                    description: "Apply to your cell's content to only show on row hover/focus"
                },
            ]
        },
    ],
    "textfield": [
        {
            "groupName": "styles",
            "items": [
                {
                    name: ".subtle.bolt-textfield",
                    description: "Apply the 'subtle' className to your TextField to have a subtle background (inherit rather than forced white/black)."
                },
                {
                    name: ".hide-border.bolt-textfield",
                    description: "Apply the 'hide-border' className to your TextField to have a border only on hover/focus."
                },
            ]
        },
    ],
    "undefined": [
        {
            "groupName": "no-sub-group",
            "items": [
                {
                    name: ".bolt-breadcrumb .bolt-button",
                    description: "When buttons are placed into a breadcrumb we will update the visuals to match the other breadcrumb items."
                },
                {
                    name: ".suggestion-text",
                    description: "text-color for clickable suggestion"
                },
                {
                    name: ".flex",
                    description: "deprecated layout style use flex-row"
                },
                {
                    name: ".fontSizeXXS",
                    description: "deprecated font style use font-size-xxs"
                },
                {
                    name: ".fontSizeXS",
                    description: "deprecated font style use font-size-xs"
                },
                {
                    name: ".fontSizeS",
                    description: "deprecated font style use font-size-s"
                },
                {
                    name: ".fontSize",
                    description: "deprecated font style use font-size"
                },
                {
                    name: ".fontSizeMS",
                    description: "deprecated font style use font-size-ms"
                },
                {
                    name: ".fontSizeM",
                    description: "deprecated font style use font-size-m"
                },
                {
                    name: ".fontSizeMM",
                    description: "deprecated font style use font-size-mm"
                },
                {
                    name: ".fontSizeML",
                    description: "deprecated font style use font-size-ml"
                },
                {
                    name: ".fontSizeL",
                    description: "deprecated font style use font-size-l"
                },
                {
                    name: ".fontSizeLL",
                    description: "deprecated font style use font-size-ll"
                },
                {
                    name: ".fontSizeLLL",
                    description: "deprecated font style use font-size-lll"
                },
                {
                    name: ".fontSizeXL",
                    description: "deprecated font style use font-size-xl"
                },
                {
                    name: ".fontSizeXXL",
                    description: "deprecated font style use font-size-xxl"
                },
                {
                    name: ".fontSizeXXXL",
                    description: "deprecated font style use font-size-xxxl"
                },
                {
                    name: ".fontSizeXXXXL",
                    description: "deprecated font style use font-size-xxxxl"
                },
                {
                    name: ".fontWeightLighter",
                    description: "deprecated font style use font-weight-light"
                },
                {
                    name: ".fontWeightNormal",
                    description: "deprecated font style use font-weight-normal"
                },
                {
                    name: ".fontWeightSemiBold",
                    description: "deprecated font style use font-weight-semibold"
                },
                {
                    name: ".fontWeightHeavy",
                    description: "deprecated font style use font-weight-heavy"
                },
            ]
        },
    ],
    "page": [
        {
            "groupName": "layout",
            "items": [
                {
                    name: ".page-content",
                    description: "Apply to your content within a page to get standard left/right/bottom padding."
                },
                {
                    name: ".page-content-top",
                    description: "Apply to your content within a page to get standard top paddding"
                },
                {
                    name: ".page-content-bottom",
                    description: "Apply to your content within a page to get standard bottom paddding"
                },
                {
                    name: ".page-content-left",
                    description: "Apply to your content within a page to get standard left paddding"
                },
                {
                    name: ".page-content-right",
                    description: "Apply to your content within a page to get standard right paddding"
                },
            ]
        },
    ],
}